<template>
  <div id="app">
    <Header />
    <AnYu style="padding-top:84px;"/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import AnYu from "@/components/AnYu/AnYu";
import Footer from "@/components/Footer/Footer";
export default {
  name: "app",
  components: {
    Header,
    AnYu,
    Footer
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  /* position: relative; */
}
body {
  background-color: #f5f8fa;
}
</style>



// WEBPACK FOOTER //
// src/App.vue